import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "trigger"]
  static values = {active: String}

  connect() {}

  triggerClick(e) {
    this.#switchTab(e.currentTarget)
  }

  next() {
    const currentTrigger = this.#findActiveTrigger()
    const currentIndex = this.triggerTargets.indexOf(currentTrigger)
    const nextIndex = currentIndex === this.triggerTargets.length - 1 ? 0 : currentIndex + 1

    this.#switchTab(this.triggerTargets[nextIndex])
  }

  prev() {
    const currentTrigger = this.#findActiveTrigger()
    const currentIndex = this.triggerTargets.indexOf(currentTrigger)
    const prevIndex = currentIndex === 0 ? this.triggerTargets.length - 1 : currentIndex - 1

    this.#switchTab(this.triggerTargets[prevIndex])
  }

  #switchTab(tab) {
    const currentTrigger = this.#findActiveTrigger()
    currentTrigger.removeAttribute("checked")
    tab.toggleAttribute("checked", true)

    const currentContent = this.#findContentTarget(this.activeValue)
    const selectedContent = this.#findContentTarget(tab.dataset.value)
    //
    currentContent.classList.add("hidden")
    selectedContent.classList.remove("hidden")
    //
    this.activeValue = tab.dataset.value
  }

  #findActiveTrigger() {
    return this.triggerTargets.find((el) => el.dataset.value === this.activeValue)
  }

  #findContentTarget(value) {
    return this.contentTargets.find((el) => el.dataset.value === value)
  }
}
